import { Box, Button, Modal, Stack, Typography } from "@mui/material";
import {
  AdminDeleteIcon,
  AdminEditIcon,
  ModalCloseIcon,
} from "../../../../../@lib/icons";
import { useLanguageTranslator } from "../../../../../components";
import { Link } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1070,
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
  py: 3,
  px: 3,
};

function DetailsView({ isOpen, handleCancel, item, onClickHandler }: any) {
  const { translator } = useLanguageTranslator();

  return (
    <Modal
      open={isOpen}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Stack
          direction={"row"}
          justifyContent={"flex-end"}
          sx={{ cursor: "pointer" }}
          mb={2}
          onClick={handleCancel}
        >
          <ModalCloseIcon />
        </Stack>
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          sx={{ backgroundColor: "#F6F6F6", px: 3, py: 1 }}
        >
          <Typography variant="h4" color="black" sx={{ fontSize: "16px" }}>
            ID : {item?.id}
          </Typography>{" "}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography
              variant="h4"
              sx={{ fontSize: "12px", display: "flex", alignItems: "center" }}
              color="#494E54"
              fontWeight={300}
            >
              {translator("dashboardTableHead.Date Created")}:{" "}
              <Typography
                variant="h4"
                color="black"
                sx={{ fontSize: "16px" }}
                fontWeight={300}
                ml={2}
              >
                {item?.createdAt}
              </Typography>{" "}
            </Typography>
            <Typography
              variant="h4"
              sx={{ fontSize: "12px", display: "flex", alignItems: "center" }}
              color="#494E54"
              ml={3}
              fontWeight={300}
            >
              {translator("dashboardTableHead.Date Updated")}:{" "}
              <Typography
                variant="h4"
                color="black"
                sx={{ fontSize: "16px" }}
                ml={2}
                fontWeight={300}
              >
                {item?.updatedAt}
              </Typography>
            </Typography>
          </Box>
        </Stack>
        <Stack sx={{ px: 3, py: 1 }}>
          <Typography
            variant="h4"
            sx={{ fontSize: "12px" }}
            color="#494E54"
            fontWeight={400}
            mt={2}
          >
            {translator("Indicator Label")}:{" "}
          </Typography>
          <Typography
            variant="h4"
            sx={{ fontSize: "12px" }}
            color="#000000"
            fontWeight={400}
            mt={1}
          >
            {item?.label}{" "}
          </Typography>
          <Stack direction={"row"} alignItems={"center"}>
            <Stack mt={2}>
              <Typography
                variant="h4"
                sx={{ fontSize: "12px" }}
                color="#494E54"
                fontWeight={400}
              >
                {translator("Country")}:{" "}
              </Typography>
              <Typography
                variant="h4"
                sx={{ fontSize: "12px" }}
                color="#000000"
                fontWeight={400}
                mt={1}
              >
                {item?.country}{" "}
              </Typography>
            </Stack>
            <Stack mt={2} ml={3}>
              <Typography
                variant="h4"
                sx={{ fontSize: "12px" }}
                color="#494E54"
                fontWeight={400}
              >
                {translator("Value")}{" "}
              </Typography>
              <Typography
                variant="h4"
                sx={{ fontSize: "12px" }}
                color="#000000"
                fontWeight={400}
                mt={1}
              >
                {item?.value}
              </Typography>
            </Stack>
          </Stack>

          <Typography
            variant="h4"
            sx={{ fontSize: "12px" }}
            color="#494E54"
            fontWeight={400}
            mt={2}
          >
            {translator("Source")}:{" "}
          </Typography>
          <Typography
            variant="h4"
            sx={{ fontSize: "12px" }}
            color="#000000"
            fontWeight={400}
            mt={1}
          >
            {item?.source}{" "}
          </Typography>
          <Typography
            variant="h4"
            sx={{ fontSize: "12px" }}
            color="#494E54"
            fontWeight={400}
            mt={2}
          >
            {translator("dashboardTableHead.Description")}:{" "}
          </Typography>
          <Typography
            variant="h4"
            sx={{ fontSize: "12px" }}
            color="#000000"
            fontWeight={400}
            mt={1}
          >
            {item?.description}{" "}
          </Typography>
        </Stack>

        <Stack direction={"row"} px={3} mt={2}>
          <Link
            to={`/admin/indicators-values/update?id=${item?.id}`}
            style={{
              backgroundColor: "transparent",
              border: "0px",
              cursor: "pointer",
              marginTop: "3px",
            }}
          >
            <AdminEditIcon />
          </Link>
          <button
            onClick={() => onClickHandler(item)}
            style={{
              backgroundColor: "transparent",
              border: "0px",
              cursor: "pointer",
            }}
          >
            <AdminDeleteIcon />
          </button>
        </Stack>
        <Stack direction={"row"} justifyContent={"center"} px={2} mt={3}>
          <Button
            onClick={handleCancel}
            sx={{
              backgroundColor: "#F6A000",
              padding: "6px 60px",
              color: "white",
              borderRadius: "10px",
              fontSize: "14px",
              textDecoration: "none",
              marginBottom: "15px",
              "&:hover": {
                backgroundColor: "#D98C00",
              },
            }}
          >
            {translator("generic.Close")}
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
}

export { DetailsView };
